import {apolloClient} from '@/setup/apollo-setup';
import {error, newItemSuccess, updateItemSuccess, deleteItemSuccess} from '@/utils/notification';
import {
  GET_COURSEOUTLINEUNIT,
  GET_COURSEOUTLINEUNITS,
  ADD_COURSEOUTLINEUNIT,
  UPDATE_COURSEOUTLINEUNIT,
  DELETE_COURSEOUTLINEUNIT
} from '@/queries/modules/courses/course-outline-unit';

export async function getCourseOutlineUnits(context) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_COURSEOUTLINEUNITS,
        fetchPolicy: 'network-only',
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return [];
    } else {
      context.commit('setCourseOutlineUnits', data.getCourseOutlineUnits);
      context.commit('setSuccess', null);
      return data.getCourseOutlineUnits
    }

  } catch (e) {
    context.commit('setError', error(e));
    return [];
  }
}

export async function getCourseOutlineUnit(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .query({
        query: GET_COURSEOUTLINEUNIT,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      context.commit('setCourseOutlineUnit', data.getCourseOutlineUnit);
      context.commit('setSuccess', null);
      return data.getCourseOutlineUnit
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function addCourseOutlineUnit(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: ADD_COURSEOUTLINEUNIT,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const courseOutlineUnits = [...context.state.courseOutlineUnits];
      courseOutlineUnits.push(data.addCourseOutlineUnit);
      context.commit('setCourseOutlineUnits', courseOutlineUnits);
      context.commit('setSuccess', newItemSuccess(data.addCourseOutlineUnit.seq));

      return data.addCourseOutlineUnit;
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function updateCourseOutlineUnit(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: UPDATE_COURSEOUTLINEUNIT,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;

    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {

      const index = context.state.courseOutlineUnits.findIndex(item => item.id === data.updateCourseOutlineUnit.id);
      const courseOutlineUnits = [
        ...context.state.courseOutlineUnits.slice(0, index),
        data.updateCourseOutlineUnit,
        ...context.state.courseOutlineUnits.slice(index + 1)
      ];
      context.commit('setCourseOutlineUnits', courseOutlineUnits);
      context.commit('setSuccess', updateItemSuccess(data.updateCourseOutlineUnit.seq));

      return data.updateCourseOutlineUnit
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

export async function deleteCourseOutlineUnit(context, payload) {
  context.commit('setProcessing', true);
  try {
    const result = await apolloClient
      .mutate({
        mutation: DELETE_COURSEOUTLINEUNIT,
        variables: payload,
        context: { clientName: 'Prisma2' }
      });

    const {data, errors} = await result;
    if (errors) {
      context.commit('setError', error(errors));
      return null;
    } else {
      const index = context.state.courseOutlineUnits.findIndex(item => item.id === data.deleteCourseOutlineUnit.id);
      const courseOutlineUnits = [
        ...context.state.courseOutlineUnits.slice(0, index),
        ...context.state.courseOutlineUnits.slice(index + 1)
      ];
      context.commit('setCourseOutlineUnits', courseOutlineUnits);
      context.commit('setSuccess', deleteItemSuccess(data.deleteCourseOutlineUnit.seq));

      return data.deleteCourseOutlineUnit
    }

  } catch (e) {
    context.commit('setError', error(e));
    return null;
  }
}

